
import {filter} from 'rxjs/operators';

import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { Observable, Subscription } from 'rxjs';


import { UserProfileService, ProductRouteInfoService, ProductData } from '../../../core';

@Component({
    selector: 'app-gray-bar-header',
    templateUrl: './gray_bar_header.component.html',
    styleUrls: ['./gray_bar_header.component.scss']
})

export class GrayBarHeaderComponent  {

  _linkList:ProductData[]=[];
  subscriptions:Subscription[]=[];
  current:string;

  @Input()
  set linkList(list:ProductData[]){
    //console.log("gray bar set " + this.router.routerState.snapshot.url) ;
    //this.current = this.router.routerState.snapshot.url;
    this._linkList = this.updating(list);
  }
  get linkList():ProductData[]{
    return this._linkList;
  };

    constructor(
        private router: Router
    ) {
    // if set linkList() has race conditions this may need to be uncommented
      this.subscriptions.push(
        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(
          ((e:NavigationEnd) => {
            this.current = this.router.routerState.snapshot.url;
            this.updating(this._linkList);
          }),
          (err)=>console.log(err)
    ));

    }
    updating(list:ProductData[]):ProductData[]{
      return list.map(link => {
          this.markAsActive(this.current,link);
        return link;
      });
    }
    markAsActive(path:string, link:ProductData):void{
      if(path)
        link.active = path.startsWith(link.mainPath);
      else
        link.active = false;
    }


}
